import logo from "../../assets/logo.png";
import { Link, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import {
  allAdmins,
  updateAdmin,
  resetAdmins,
  addAdmins,
  canselarReserva,
} from "../../store/modules/admin/actions";

const SideBar = () => {
  const dispatch = useDispatch();
  const {
    clientes,
    behavior,
    form,
    components,
    code,
    loginCliente,
    step1,
    step2,
    auth,
  } = useSelector((state) => state.admin);

  const setComponent = (component, state) => {
    dispatch(
      updateAdmin({
        components: { ...components, [component]: state },
      })
    );
  };

  return (
    <sidebar className="d-flex  flex-column align-items-center bg-warning">
      <img
        src={logo}
        className=" col-12 col-md-12 col-sd-12 col-xl-12 mt-1 p-0 "
      />

      <ul className="p-0 m-0">
        <li>
          <button
            className="col-xl-12 col-12  mt-2 bg-light br-1 rounded "
            onClick={() => {
              dispatch(
                updateAdmin({
                    behavior:"Calendary"
                })
              );
            }}
          >
            <span className="mdi mdi-calendar-check bg-light   "></span>
          </button>
        </li>
        <li>
          <button className="col-xl-12 col-12  mt-2 bg-light rounded"
           onClick={() => {
            dispatch(
              updateAdmin({
                  behavior:"clientesList"
              })
            );
          }}
          >
            <span className="mdi mdi-account-multiple bg-light"></span>
          </button>
        </li>
        <li>
          <button className="col-xl-12 col-12  mt-2 bg-light rounded"
           onClick={() => {
            dispatch(
              updateAdmin({
                  behavior:"carros"
              })
            );
          }}
          >
            <span className="mdi mdi-card-account-details-outline bg-light"></span>
          </button>
        </li>
        <li>
          <button className=" col-xl-12 col-12  mt-2 bg-light rounded"
           onClick={() => {
            dispatch(
              updateAdmin({
                  behavior:"admins"
              })
            );
          }}
          >
            <span className="mdi mdi-auto-fix bg-light"></span>
          </button>
        </li>
        <li>
          <button className="col-xl-12 col-12 mt-2 bg-light rounded"
           onClick={() => {
            dispatch(
              updateAdmin({
                  behavior:"Vans"
              })
            );
          }}
          >
            <span className="mdi mdi-clock-check-outline bg-light"></span>
          </button>
        </li>
      </ul>
    </sidebar>
  );
};

export default SideBar;
